export default "__VITE_ASSET__4fbdde33__"